import { extraChargeConstants } from "../../constants";
import { extraChargeService } from "../../services";
import { alertActions } from "../alert.actions";

export const extraChargeActions = {
  getSingleParameter,
  getAllParameters,
  addParameter,
  updateParameter,
  deleteParameter,
  clear,
};

// get single parameter
function getSingleParameter() {}

// get all parameter
function getAllParameters() {
  return (dispatch) => {
    dispatch(request());

    extraChargeService.getAllParameters().then(
      (items) => dispatch(success(items)),
      (error) => dispatch(failure(error))
    );
  };

  function request(params) {
    return { type: extraChargeConstants.GET_ALL_REQUEST, params };
  }
  function success(items) {
    return { type: extraChargeConstants.GET_ALL_SUCCESS, items };
  }
  function failure(error) {
    return { type: extraChargeConstants.GET_ALL_FAILURE, error };
  }
}

// add parameter
function addParameter(name, code, type, cost, status) {
  return (dispatch) => {
    dispatch(request(name, code, type, cost, status));

    extraChargeService.addParameter(name, code, type, cost, status).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: extraChargeConstants.ADD_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: extraChargeConstants.ADD_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: extraChargeConstants.ADD_FAILURE, error };
  }
}

// update parameter
function updateParameter(id, name, code, type, cost, status) {
  return (dispatch) => {
    dispatch(request(id, name, code, type, cost, status));

    extraChargeService.updateParameter(id, name, code, type, cost, status).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: extraChargeConstants.UPDATE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: extraChargeConstants.UPDATE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: extraChargeConstants.UPDATE_FAILURE, error };
  }
}

// delete parameter
function deleteParameter(id) {
  return (dispatch) => {
    dispatch(request(id));

    extraChargeService.deleteParameter(id).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: extraChargeConstants.DELETE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: extraChargeConstants.DELETE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: extraChargeConstants.DELETE_FAILURE, error };
  }
}

// clear parameter
function clear() {
  return { type: extraChargeConstants.CLEAR };
}
